import { campaignTextKeys as horizontalSigningTextKeys, API_MODULE_HORIZONTAL_SIGNING } from "@l2r-front/l2r-app-city"
import { TranslationFunction } from "@l2r-front/l2r-i18n"

type CampaignTextKeys = {
    namespace: string
    [key: string]: string
}

const getCampaignTextKeys = (campaignType: string): CampaignTextKeys | undefined => {
    switch (campaignType) {
        case API_MODULE_HORIZONTAL_SIGNING:
            return horizontalSigningTextKeys
    }
}

export const useCampaignTexts = (campaignType: string, t: TranslationFunction) => {
    const textKeys = getCampaignTextKeys(campaignType)

    if (!textKeys) {
        return undefined
    }

    const { namespace, ...keys } = textKeys

    return Object.fromEntries(
        Object.entries(keys).map(([key, textKey]) => [key, t(namespace, textKey)])
    )
}
